<div class="row">
  <div class="col-12">
    <h4 [innerHTML]="translationService.getTranslation('childUser.informationHeadline')"></h4>
  </div>
  <div class="col-12"
       [innerHTML]="translationService.getTranslation('childUser.informationMessage')">
  </div>
</div>
